import react, { useState } from "react";
import NoteContext from "./noteContext";
const NoteState = (props) => {
  const host = "http://localhost:5000"
  // const s1  ={
  //     "name" : "hello",
  //     "subname" :"world"
  // }
  // const [state, setState] = useState(s1);
  // const  update = () =>{
  //     setTimeout(()=> {
  //         setState({
  //             "name": "hiiihlo",
  //             "subname": "worldworld"
  //         })
  //     })
  // }
  const notesInitial = []
  const [notes, setNotes] = useState(notesInitial);

  const getNotes = async(title,description,tag ) =>{
    const response = await fetch(`${host}/api/notes/fetchallnotes`,{
      method: 'GET',
      headers  :{
        'Content-Type' : 'application/json',
        'auth-token' : localStorage.getItem('token')
      }
    }); 
    const json = await response.json()
    
    setNotes(json)
}
  const addNote = async(title, description, tag ) =>{
      const response = await fetch(`${host}/api/notes/addnote`,{
        method: 'POST',
        headers  :{
          'Content-Type' : 'application/json',
           "auth-token" : localStorage.getItem('token')
        },
        body  : JSON.stringify({title, description, tag})
      });

    const note = await response.json();
    setNotes(notes.concat(note)) //concate returns a array & push updatesan array

//Add a Note
 
}
//delete note
const deleteNote = async(id ) =>{
  const response = await fetch(`${host}/api/notes/deletenote/${id}`,{
    method: 'DELETE',
    headers  :{
      'Content-Type' : 'application/json',
      'auth-token' : localStorage.getItem('token')
    },
  });
  const json = response.json();
  console.log(json)

  console.log("deleting note with id" ,id);
  const newNotes = notes.filter((note)=>{
   return note._id !== id
  })
  setNotes(newNotes)
}



//edit
const editNote = async (id, title,description,tag ) =>{
  const response = await fetch(`${host}/api/notes/updatenote/${id}`,{
    method: 'PUT',
    headers  :{
      'Content-Type' : 'application/json',
      'auth-token' : localStorage.getItem('token')
    },
    body  : JSON.stringify({title, description, tag})
  });
  
const json = await response.json();

let newNotes = JSON.parse(JSON.stringify(notes))

  for(let i=0 ; i<newNotes.length ; i++){
    const element = newNotes[i];
    if(element._id === id){
      newNotes[i].title = title;
      newNotes[i].description = description;
      newNotes[i].tag = tag;
      break;
    }
  }
  setNotes(newNotes);
}

  return (
    <NoteContext.Provider value={{notes,addNote,deleteNote, editNote, getNotes}}>
        {props.children}
        </NoteContext.Provider>
  )
  };
export default NoteState;
